import req from './../../../fetch';
import { undocumentedResponse } from './../../../utils';
import {
  AllAPIResponses,
  CarbonError,
  UserSubscriptionType,
} from './../../../index';

type Payload = {
  notificationSchemaIds: number[];
  // example: 01234|02:04-03:04,04:04-05:04; 12|12:00-13:00;
  schedule?: string;
  userId: number;
};
const post = async (
  payload: Payload,
  headers?: Headers
): Promise<AllAPIResponses<UserSubscriptionType[]>> => {
  try {
    const resp = await req.post(
      '/api/usersubscriptions/batch',

      JSON.stringify(payload),
      headers
    );
    const clone = resp.clone();
    switch (resp.status) {
      case 201:
        return {
          data: (await resp.json()) as UserSubscriptionType[],
          response: clone,
        };
      case 400:
      case 401:
      case 403:
      case 404:
      case 500:
        return {
          error: (await resp.json()) as CarbonError,
          response: clone,
        };
      default:
        return {
          error: new Error(undocumentedResponse(resp)),
          response: clone,
        };
    }
  } catch (e) {
    return { error: e, response: undefined };
  }
};

export default post;
